import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import EditIcon from '@material-ui/icons/Edit';
import { CheckCircle } from '@material-ui/icons';
import DoneIcon from '@material-ui/icons/Done';

export const getDefaultActions = (
  resource,
  hidden,
  toggleHide,
  completed,
  userCanUpdateActionItem,
  handleEditTask,
  isAccountAi,
  markAsComplete,
) => {
  return [
    {
      key: `toggle-hide-${resource.id()}`,
      label: (hidden) ? 'Unhide Task' : 'Hide Task',
      onClick: () => toggleHide(),
      icon: (hidden) ? VisibilityIcon : VisibilityOffIcon,
      hidden: !completed || !userCanUpdateActionItem,
    },
    {
      key: `edit-${resource.id()}`,
      label: 'Edit task',
      onClick: () => handleEditTask(),
      icon: EditIcon,
      hidden: completed || !userCanUpdateActionItem || isAccountAi,
    },
    {
      key: `mark-complete-${resource.id()}`,
      label: completed ? 'Completed' : 'Mark Complete',
      disabled: completed,
      onClick: () => markAsComplete(),
      icon: completed ? CheckCircle : DoneIcon,
      hidden: (!completed && !userCanUpdateActionItem) || isAccountAi,
    },
  ];
};
